import type { MonitorUptime } from '@fos/shared/contracts/monitoring';
import { uptimeText } from '@fos/shared/labels';
import { cn } from '../../../lib/cn';
import { formatDateShort } from '../../../lib/format';
import { TONE_DOT } from '../../../ui/Status';
import { uptimeDayTone } from '../monitoring-format';

/**
 * Pasek dostępności z 30 dni (MODULE_UTRZYMANIE §5): jeden słupek na dzień (Europe/Warsaw), kolor tylko gdy niesie
 * znaczenie — zielony 100%, pomarańczowy drobne przerwy, czerwony awaria, szary brak sprawdzeń. Bez biblioteki wykresów.
 */
export function UptimeBar({ uptime, className }: { uptime: MonitorUptime; className?: string }) {
  const label = `Dostępność z ${uptime.windowDays} dni: ${uptimeText(uptime.percent)}`;
  return (
    <div role="img" aria-label={label} className={cn('flex h-5 items-stretch gap-[2px]', className)}>
      {uptime.days.map((d) => {
        const tone = uptimeDayTone(d);
        return (
          <span
            key={d.date}
            title={`${formatDateShort(d.date)}: ${d.total === 0 ? 'brak sprawdzeń' : uptimeText(d.percent)}`}
            className={cn('min-w-0 flex-1 rounded-[2px]', tone ? TONE_DOT[tone] : 'bg-elevated')}
          />
        );
      })}
    </div>
  );
}
